import React from "react";
import { useTable, usePagination } from "react-table";
import { useRef } from "react";
import { Table } from "../../styles-components/Table";
import { ButtonPagination } from "../../styles-components/Buttons";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";

const TablePaginationMore = ({
  header,
  columnsData,
  contentData,
  type,
  pageSizeValue
}) => {
  const columns = React.useMemo(
    () => [
      {
        Header: header,
        columns: columnsData
      }
    ],
    [columnsData]
  );

  const tableRef = useRef(null);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    state: { pageIndex },
  } = useTable(
    {
      columns,
      data: contentData,
      initialState: { pageIndex: 0, pageSize: pageSizeValue },
    },
    usePagination
  );

  return (
    <>
      <Table ref={tableRef} {...getTableProps()} type={type}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>

      <div>
        <ButtonPagination
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          <IoIosArrowBack />
        </ButtonPagination>
        <ButtonPagination
          onClick={() => {
            tableRef.current.focus();
            nextPage();
          }}
          disabled={!canNextPage}
        >
          <IoIosArrowForward />
        </ButtonPagination>
        <span>
          Página{' '}
          <strong>
            {pageIndex + 1} de {pageOptions.length}
          </strong>{' '}
        </span>
      </div>
    </>
  );
};

export default TablePaginationMore;
